<template lang="html">
  <svg class="icon-svg" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.1573 14.8823L13.9703 16.0562C13.0954 16.9149 11.9603 18.0188 10.5644 19.3684C9.6922 20.2117 8.3084 20.2116 7.4362 19.3681L3.94515 15.9723C3.50638 15.5414 3.13912 15.1781 2.84328 14.8823C-0.557134 11.4819 -0.557134 5.96872 2.84328 2.56831C6.24369 -0.832097 11.7568 -0.832097 15.1573 2.56831C18.5577 5.96872 18.5577 11.4819 15.1573 14.8823ZM11.5005 9C11.5005 7.61918 10.3811 6.4998 9.0003 6.4998C7.6194 6.4998 6.50006 7.61918 6.50006 9C6.50006 10.3808 7.6194 11.5002 9.0003 11.5002C10.3811 11.5002 11.5005 10.3808 11.5005 9Z" fill="#ADA8A8"/>
  </svg>
</template>
<script>
    export default {
        name: 'IconMarker'
    }
</script>



// WEBPACK FOOTER //
// src/components/icons/IconMarker.vue